export const courses = [
    { name: 'Yabancı Dil I (İngilizce)', emoji: '🗣️', harfnotu: 'AA', vize: 100, final: 100 },
    { name: 'Yabancı Dil II (İngilizce)', emoji: '🗣️', harfnotu: 'AA', vize: 100, final: 100 },

    { name: 'Atatürk İlkeleri ve İnkılap Tarihi-I', emoji: '📜', harfnotu: 'AA', vize: 96, final: 88 },
    { name: 'Programlama I', emoji: '💻', harfnotu: 'AA', vize: 100, final: 94 },
    { name: 'Lineer Cebir', emoji: '➕', harfnotu: 'AA', vize: 80, final: 90 },
    { name: 'Bilgisayar Mühendisliğine Giriş', emoji: '🚀', harfnotu: 'AA', vize: 95, final: 90 },
    { name: 'Programlama Lab I', emoji: '🧪', harfnotu: 'AA', vize: 90, final: 90, odev: 100 },
    { name: 'Fizik I', emoji: '🧲', harfnotu: 'BA', vize: 100, final: 80 },
    { name: 'Fizik I Laboratuvar', emoji: '🔬', harfnotu: 'AA', vize: 100, final: 100 },
    { name: 'Matematik I', emoji: '📐', harfnotu: 'BB', vize: 63, final: 72 },
    { name: 'Türk Dili I', emoji: '📝', harfnotu: 'CB', vize: 60, final: 85 },

    { name: 'Atatürk İlkeleri ve İnkılap Tarihi II', emoji: '📜', harfnotu: 'AA', vize: 92, final: 93 },
    { name: 'Ayrık Matematik', emoji: '🔢', harfnotu: 'CB', vize: 55, final: 70 },
    { name: 'Programlama II', emoji: '🖥️', harfnotu: 'BA', vize: 79, final: 79 },
    { name: 'Programlama Lab II', emoji: '🧪', harfnotu: 'AA', vize: 100, final: 87, odev: 100 },
    { name: 'Fizik II', emoji: '⚛️', harfnotu: 'AA', vize: 78, final: 80 },
    { name: 'Fizik II Laboratuvar', emoji: '🔬', harfnotu: 'BA', vize: 65, final: 90 },
    { name: 'İstatistik', emoji: '📊', harfnotu: 'AA', vize: 80, final: 90 },
    { name: 'Matematik II', emoji: '📐', harfnotu: 'AA', vize: 43, final: 97 },
    { name: 'Türk Dili II', emoji: '📝', harfnotu: 'BB', vize: 60, final: 80 },

    { name: 'Diferansiyel Denklemler', emoji: '🔣', harfnotu: 'AA', vize: 100, final: 100 },

    { name: 'Elektronik Devreler', emoji: '🔌', harfnotu: 'BA', vize: 80, final: 85 },
    { name: 'Elektronik Devreler Lab.', emoji: '🧪', harfnotu: 'CB', vize: 60, final: 68.8, uygulama1: 93.33, uygulama2: 58 },
    { name: 'Veri Yapıları ve Algoritmalar', emoji: '🌳', harfnotu: 'BA', vize: 90, final: 80 },
    { name: 'Nesneye Yönelik Programlama', emoji: '🧱', harfnotu: 'AA', vize: 92, final: 90 },
    { name: 'Python Programlama', emoji: '🐍', harfnotu: 'AA', vize: 74, final: 100 },
    { name: 'Girişimcilik', emoji: '🚀', harfnotu: 'AA', vize: 100, final: 85 },
    { name: 'Bilgisayar Destekli Teknik Çizim', emoji: '🖊️', harfnotu: 'AA', vize: 100, final: 84 },

    { name: 'İnternet Programlama', emoji: '🌐', harfnotu: 'AA', vize: 80, final: 95 },
    { name: 'Sayısal Tasarım', emoji: '📐', harfnotu: 'BB', vize: 73, final: 75 },
    { name: 'Sayısal Tasarım Lab', emoji: '🧪', harfnotu: 'AA', vize: 90, final: 81, uygulama: 97 },
    { name: 'Görsel Programlama', emoji: '🖼️', harfnotu: 'AA', vize: 100, final: 100 },
    { name: 'Nümerik Analiz', emoji: '📊', harfnotu: 'CB', vize: 70, final: 53 },
    { name: 'Girişimcilik II', emoji: '🚀', harfnotu: 'CB', vize: 80, final: 58 },
    { name: 'İş Hukuku', emoji: '⚖️', harfnotu: 'BB', vize: 90, final: 60 },
    {name: 'Staj I', emoji: '🛠️', harfnotu: 'YT'},

    { name: 'Bilgisayar Organizasyonu', emoji: '🖥️', harfnotu: 'AA', vize: 90, final: 96, odev: 100 },
    { name: 'Bilgisayar Ağları', emoji: '🌐', harfnotu: 'AA', vize: 77, final: 84 },
    { name: 'Biçimsel Diller ve Otomatlar', emoji: '🤖', harfnotu: 'BA', vize: 85, final: 60 },
    { name: 'Veritabanı Yönetim Sistemleri', emoji: '🗄️', harfnotu: 'AA', vize: 97, final: 98 },
    { name: 'Biyoinformatiğe Giriş', emoji: '🧬', harfnotu: 'BA', vize: 85, final: 90 },
    { name: 'İş Sağlığı ve Güvenliği I', emoji: '🦺', harfnotu: 'BB', vize: 95, final: 75 },
    { name: 'Teknoloji Bağımlılığı', emoji: '📱', harfnotu: 'AA', vize: 90, final: 97 },
];

export const gradeInfo = {
    'AA': { emoji: '🐐', color: '#4CAF50' },
    'BA': { emoji: '😊', color: '#8BC34A' },
    'BB': { emoji: '🙂', color: '#CDDC39' },
    'CB': { emoji: '😐', color: '#FFC107' },
    'CC': { emoji: '🫠', color: '#FF9800' },
    'DC': { emoji: '😢', color: '#FF5722' },
    'DD': { emoji: '😭', color: '#F44336' },
    'FF': { emoji: '💀', color: '#D32F2F' },
    'YT': { emoji: '✅', color: '#4CAF50' }, 
    '--': { emoji: '🕵️‍♂️', color: '#9E9E9E' },
}; 